import { EntityList } from '@avangard/utils/entity';

import { StudentProfileGroupEntity } from './student-profile-group.entity';

import type { Entity } from './student-profile-group.entity';

class StudentProfileGroupEntityList extends EntityList<StudentProfileGroupEntity> {
    constructor(items: Entity[] | null, count?: number | null) {
        super(StudentProfileGroupEntity, items, count);
    }
}

export { StudentProfileGroupEntityList };
